import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import SocialAdsBuilderModal from './SocialAdsBuilderModal';

export default function FacebookAdsModal({ isOpen, onClose }) {
  const [inputs, setInputs] = useState({
    headline: 'معاً نكرم محاربينا القدامى. استمتع بخصم 25% على جميع الطلبات واجعل هذا الموسم لا ينسى',
    description: 'خصم 25% عروض تخفيضات يوم المحاربين القدامى'
  });
  const [showSocialAdsBuilder, setShowSocialAdsBuilder] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleGenerate = () => {
    // TODO: Implement generate functionality
    console.log('Generated content:', inputs);
  };

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl sm:p-6">
                <div className="absolute right-0 top-0 pr-4 pt-4">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>

                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                    <Dialog.Title as="h3" className="text-xl font-semibold leading-6 text-gray-900 mb-4">
                      Add Headline Caption To Facebook Ad
                    </Dialog.Title>

                    <div className="bg-gray-50 p-6 rounded-lg mb-6">
                      <div className="max-w-md mx-auto bg-white rounded-lg overflow-hidden shadow">
                        <div className="p-4">
                          <div className="flex items-center space-x-2 mb-3">
                            <img 
                              src="https://i.ibb.co/YkwGqLQ/Screenshot-2024-11-14-at-3-38-45-PM-removebg-preview-1.png" 
                              alt="Profile" 
                              className="w-10 h-10 rounded-full"
                            />
                            <div className="flex flex-col items-start">
                              <div className="text-[15px] font-semibold">rinawi</div>
                              <div className="text-[13px] text-gray-500">Just now</div>
                            </div>
                          </div>

                          <p className="text-[14px] mb-4" dir="rtl">
                            {inputs.headline}
                          </p>

                          <div className="w-full aspect-[4/5] bg-gray-100 rounded-lg mb-4">
                            <img 
                              src="https://i.ibb.co/82xMFc1/NOV002-2-07abbaea-3e7d-4c61-8034-9d6593ae1833-1080x.webp"
                              alt="Ad"
                              className="w-full h-full object-contain"
                            />
                          </div>

                          <div className="flex flex-col space-y-2">
                            <div className="text-[12px] text-gray-500">
                              rinawi-food-inc.myshopify.com
                            </div>
                            <div className="flex items-center justify-between">
                              <div className="text-[14px]" dir="rtl">{inputs.description}</div>
                              <button className="px-4 py-2 bg-gray-100 text-gray-800 rounded-md text-[14px] whitespace-nowrap hover:bg-gray-200">
                                Shop Now
                              </button>
                            </div>
                          </div>

                          <div className="flex items-center justify-between mt-4 pt-3 border-t border-gray-200">
                            <div className="flex items-center space-x-2">
                              <svg className="w-4 h-4" viewBox="0 0 16 16">
                                <defs>
                                  <linearGradient id="paint0_linear_15251_63610" x1="2.3989" y1="2.3999" x2="13.5983" y2="13.5993" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#02ADFC"/>
                                    <stop offset=".5" stopColor="#0866FF"/>
                                    <stop offset="1" stopColor="#2B7EFF"/>
                                  </linearGradient>
                                  <radialGradient id="paint1_radial_15251_63610" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(90 .0005 8) scale(7.99958)">
                                    <stop offset=".5618" stopColor="#0866FF" stopOpacity="0"/>
                                    <stop offset="1" stopColor="#0866FF" stopOpacity=".1"/>
                                  </radialGradient>
                                  <radialGradient id="paint2_radial_15251_63610" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="rotate(45 -4.5257 10.9237) scale(10.1818)">
                                    <stop offset=".3143" stopColor="#02ADFC"/>
                                    <stop offset="1" stopColor="#02ADFC" stopOpacity="0"/>
                                  </radialGradient>
                                </defs>
                                <path d="M16.0001 7.9996c0 4.418-3.5815 7.9996-7.9995 7.9996S.001 12.4176.001 7.9996 3.5825 0 8.0006 0C12.4186 0 16 3.5815 16 7.9996Z" fill="url(#paint0_linear_15251_63610)"/>
                                <path d="M16.0001 7.9996c0 4.418-3.5815 7.9996-7.9995 7.9996S.001 12.4176.001 7.9996 3.5825 0 8.0006 0C12.4186 0 16 3.5815 16 7.9996Z" fill="url(#paint1_radial_15251_63610)"/>
                                <path d="M16.0001 7.9996c0 4.418-3.5815 7.9996-7.9995 7.9996S.001 12.4176.001 7.9996 3.5825 0 8.0006 0C12.4186 0 16 3.5815 16 7.9996Z" fill="url(#paint2_radial_15251_63610)" fillOpacity=".5"/>
                                <path d="M7.3014 3.8662a.6974.6974 0 0 1 .6974-.6977c.6742 0 1.2207.5465 1.2207 1.2206v1.7464a.101.101 0 0 0 .101.101h1.7953c.992 0 1.7232.9273 1.4917 1.892l-.4572 1.9047a2.301 2.301 0 0 1-2.2374 1.764H6.9185a.5752.5752 0 0 1-.5752-.5752V7.7384c0-.4168.097-.8278.2834-1.2005l.2856-.5712a3.6878 3.6878 0 0 0 .3893-1.6509l-.0002-.4496ZM4.367 7a.767.767 0 0 0-.7669.767v3.2598a.767.767 0 0 0 .767.767h.767a.3835.3835 0 0 0 .3835-.3835V7.3835A.3835.3835 0 0 0 5.134 7h-.767Z" fill="#fff"/>
                              </svg>
                              <span className="text-[14px] text-gray-500">216</span>
                            </div>
                            <div className="flex items-center space-x-4">
                              <span className="text-[14px] text-gray-500">117 comments</span>
                              <span className="text-[14px] text-gray-500">44 shares</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="space-y-4">
                      <div>
                        <label htmlFor="headline" className="block text-sm font-medium text-gray-700 mb-1">
                          Ad Headline
                        </label>
                        <div className="flex items-center space-x-4">
                          <input
                            type="text"
                            id="headline"
                            name="headline"
                            value={inputs.headline}
                            onChange={handleInputChange}
                            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                            placeholder="Enter ad headline..."
                            dir="rtl"
                          />
                        </div>
                      </div>

                      <div>
                        <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
                          Ad Description
                        </label>
                        <div className="flex items-center space-x-4">
                          <input
                            type="text"
                            id="description"
                            name="description"
                            value={inputs.description}
                            onChange={handleInputChange}
                            className="w-full rounded-lg border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                            placeholder="Enter ad description..."
                            dir="rtl"
                          />
                        </div>
                      </div>

                      <div className="flex justify-end">
                        <button
                          onClick={handleGenerate}
                          className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 mr-4"
                        >
                          Save Generation
                        </button>
                        <button
                          onClick={() => setShowSocialAdsBuilder(true)}
                          className="px-4 py-2 bg-[#0049ac] text-white rounded-lg hover:bg-[#0049ac]/90"
                        >
                          Generate New Image
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
        <SocialAdsBuilderModal 
          isOpen={showSocialAdsBuilder} 
          onClose={() => setShowSocialAdsBuilder(false)} 
        />
      </Dialog>
    </Transition.Root>
  );
}